import config from '@/api/config'

let subUrl = '/product'

export default {
  // filterProduct: {
  //   url: function({ q }) {
  //     return config.baseUrl + config.version2 + subUrl + '/filter'
  //       + '?q=' + q
  //   }
  // },
  // getProduct: {
  //   url: function(id) {
  //     return config.baseUrl + config.version2 + subUrl + '/' + id
  //   }
  // },
  getPopularProducts: {
    url: function () {
      return config.baseUrl + config.version3 + subUrl + '/popular'
    }
  },
  search: {
    url: function () {
      return config.baseUrl + config.version3 + subUrl + '/search'
    }
  }
}
